import PropTypes from 'prop-types'
import React, { Component } from 'react'
import moment from 'moment-timezone'
import classnames from 'classnames'
import isEqual from 'lodash/isEqual'
import exact from 'prop-types-exact'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { fetchStatsForItems } from '../../components/item/itemsActions'
import ItemLink from './ItemLink'
import ItemDetails from './ItemDetails'
import ItemBatchToggle from './ItemBatchToggle'
import ItemBatch from './ItemBatch'
import ItemActionsWidget from './ItemActionsWidget'
import { SVG_ICON_ELLIPSIS, SVG_ICON_PAYWALL } from '../util/svgIcons'
import './item.pcss'
import { fetchBatchItems } from './itemsActions'

export default class Item extends Component {
  constructor(props) {
    super(props)

    this.state = {
      actionsVisible: false,
      batchVisible: false,
      batchLoading: false,
    }
  }

  render() {
    const {
      item,
      timestamp,
      dispatch,
      loggedIn,
      isTagView,
      isInsideBatch,
    } = this.props

    const blacklistedByTag = item.get('tags').find(tag => tag.get('blacklisted') === true)
    const blacklistedByCategory = item.getIn(['category', 'blacklisted'])
    const itemTimestamp = item.get('timestamp')
    const paywalled = item.get('paywalled', false)
    const blackListedBySource = item.get('blacklistedSource')
    const batchId = item.get('batchId')
    const batchSize = item.get('batchSize')

    return (
      <article className={ classnames('item', { blacklisted: blacklistedByCategory || (blacklistedByTag && !isTagView) || blackListedBySource }, { paywalled: paywalled }) }>
        <div className='item-row'>
          <ItemBatchToggle
            hasBatches={ !isInsideBatch && batchSize > 1 }
            batchVisible={ this.state.batchVisible }
            onItemBatchSwitch={ this.handleItemBatchSwitch }
          />

          <div className='item-text'>
            <h4 className='item-title'>
              { paywalled &&
                <svg className='item-title__paywalled' aria-hidden='true'>
                  <use href={ `#${SVG_ICON_PAYWALL}` } />
                </svg>
              }
              <ItemLink
                item={ item }
                dispatch={ dispatch }
                gaItemClickUiElement='Uutislista'
              />
            </h4>
            <ItemDetails
              item={ item }
              isToday={ moment(itemTimestamp * 1000).isAfter(moment(timestamp).subtract(24, 'hours')) }
            />
          </div>

          <button
            type='button'
            className='item-actions-toggle'
            onClick={ this.handleToggleActions }
            tabIndex='0'
            aria-label='Avaa uutisen toimintavalikko äänestystä ja jakamista varten'
          >
            <svg className='item-actions-toggle-icon' aria-hidden='true'>
              <use href={ `#${SVG_ICON_ELLIPSIS}` } />
            </svg>
          </button>
        </div>

        { this.state.actionsVisible && (
          <ItemActionsWidget
            item={ item }
            loggedIn={ loggedIn }
            dispatch={ dispatch }
          />
        ) }

        { batchSize > 1 && this.state.batchVisible && (
          <ItemBatch
            parentItemId={ item.get('id') }
            batchId={ batchId }
            loading={ this.state.batchLoading }
            dispatch={ dispatch }
            loggedIn={ loggedIn }
            timestamp={ timestamp }
          />
        ) }
      </article>
    )
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      !nextProps.item.equals(this.props.item) ||
      !isEqual(this.state, nextState)
    )
  }

  handleToggleActions = e => {
    const { dispatch, item } = this.props

    if (!this.state.actionsVisible) {
      dispatch(fetchStatsForItems([item.get('id')]))
    }

    this.setState({
      actionsVisible: !this.state.actionsVisible,
    })
  }

  handleItemBatchSwitch = async (e) => {
    if (this.state.batchVisible) {
      this.setState({ batchVisible: false })
      return
    }

    const batchId = this.props.item.get('batchId')
    const dispatch = this.props.dispatch
    this.setState({ batchVisible: true, batchLoading: true })
    await dispatch(fetchBatchItems(batchId))
    this.setState({ batchLoading: false })
  }
}

Item.propTypes = exact({
  item: ImmutablePropTypes.mapContains({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    source: PropTypes.string.isRequired,
    tags: ImmutablePropTypes.listOf(ImmutablePropTypes.mapContains({
      slug: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      whitelisted: PropTypes.bool.isRequired,
      blacklisted: PropTypes.bool.isRequired,
    })).isRequired,
    plus_votes: PropTypes.number.isRequired,
    minus_votes: PropTypes.number.isRequired,
    clicks: PropTypes.number.isRequired,
  }),
  timestamp: PropTypes.number.isRequired,
  dispatch: PropTypes.func.isRequired,
  loggedIn: PropTypes.bool.isRequired,
  isTagView: PropTypes.bool,
  isInsideBatch: PropTypes.bool,
})
